<template>
  <div class="submit">
    <!-- <img src="../assets/contact.png" alt="" class="submit-top"> -->
    <div class="submit-background">
      <div class="submit-content">
        <p>您可以填写表单信息 我们将尽快与您联系</p>
        <div class="submit-content-sub">
          金币数:{{ logon.coins || "0" }}（一次发布扣除2个金币）
        </div>

        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="180px"
        >
          <el-form-item prop="type" label="项目类型">
            <el-select v-model="ruleForm.type" placeholder="请选择项目类型">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="projectName" label="项目名称">
            <el-input
              v-model="ruleForm.projectName"
              placeholder="请输入项目名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="projectSpend" label="项目预算">
            <el-select
              v-model="ruleForm.projectSpend"
              placeholder="请选择预算范围"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="projectDescribe" label="项目描述">
            <el-input
              type="textarea"
              placeholder="请输入项目描述"
              v-model="ruleForm.projectDescribe"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="expectDay" label="交付周期(天)">
            <el-input
              v-model.number="ruleForm.expectDay"
              placeholder="请输入期望交付周期"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contacts" label="联系人">
            <el-input
              v-model="ruleForm.contacts"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contactPhone" label="您的联系方式">
            <el-input
              v-model="ruleForm.contactPhone"
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contactAdd" label="您的联系地址">
            <el-input
              v-model="ruleForm.contactAdd"
              placeholder="请输入联系地址"
            ></el-input>
          </el-form-item>
          <el-form-item prop="coverPic" label="参考图片">
            <el-upload
              ref="uploadRef"
              class="upload"
              action="http://8.136.151.147:8087/oss/upload"
              :data="getObject"
              :on-success="handleUploadSuccess"
              :before-upload="beforeAvatarUpload"
              v-show="false"
            >
            </el-upload>
            <div class="imgaeList">
              <div
                v-for="(item, index) in ruleForm.proPicList"
                :key="index"
                class="list"
              >
                <img :src="item" />
                <span class="mask">
                  <img
                    src="../assets/delete.png"
                    class="delete"
                    @click="handleRemove(item, index)"
                  />
                </span>
              </div>
              <div class="list2" @click="handleUpload">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </div>
          </el-form-item>
          <!-- ========== 新增：用户协议勾选框 ========== -->
          <el-form-item prop="agree" label-width="0">
            <el-checkbox v-model="ruleForm.agree">
              我已阅读并同意
              <span class="agreement-link" @click="goAgreement"
                >《平台用户协议及审核管理制度》</span
              >
            </el-checkbox>
          </el-form-item>
        </el-form>
        <div class="submit-content-div">
          <!-- ========== 修改：新增禁用状态，未勾选无法点击 ========== -->
          <div
            class="submit-content-send"
            :class="{ 'is-disabled': !ruleForm.agree }"
            @click="ruleForm.agree && handleSubmit('ruleForm')"
          >
            {{ name }}
          </div>
          <div
            class="submit-content-delete"
            v-if="name == '修改'"
            @click="handleDelete()"
          >
            删除
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  publishItem,
  getDetail,
  updateList,
  getToken,
  deleteById,
} from "../utils/publish";
export default {
  name: "topsubmit",
  components: {},
  data() {
    return {
      ruleForm: {
        type: "",
        projectName: "",
        projectSpend: "",
        projectDescribe: "",
        expectDay: undefined,
        contactPhone: "",
        contacts: "",
        contactAdd: "",
        proPicList: [],
        // ========== 新增：协议勾选状态字段 ==========
        agree: false,
      },
      accessToken: undefined,
      name: "提交",
      rules: {
        type: [
          { required: true, message: "请选择项目类型", trigger: "change" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        projectSpend: [
          { required: true, message: "请选择预算范围", trigger: "change" },
        ],
        projectDescribe: [
          { required: true, message: "请输入项目描述", trigger: "blur" },
        ],
        expectDay: [
          { required: true, message: "请输入期望交付周期", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        // ========== 新增：协议勾选校验规则 ==========
        agree: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请阅读并同意平台协议后再提交"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      options: [
        {
          label: "3万以下",
          value: "1",
        },
        {
          label: "3万-10万",
          value: "2",
        },
        {
          label: "10万-50万",
          value: "3",
        },
        {
          label: "50万以上",
          value: "4",
        },
      ],
      options2: [
        {
          label: "广告策划",
          value: 1,
        },
        {
          label: "企业咨询",
          value: 2,
        },
        {
          label: "数字内容制作",
          value: 3,
        },
        {
          label: "系统平台搭建",
          value: 4,
        },
      ],
      logon: {},
    };
  },
  created() {
    this.getStatus();
    this.logon = JSON.parse(localStorage.getItem("loginstate")) || {};
  },
  mounted() {
    this.getStatus();
  },

  computed: {
    getObject() {
      let token = this.accessToken;
      return { token };
    },
  },
  methods: {
    getStatus() {
      let data = {
        mobilePhone: JSON.parse(localStorage.getItem("loginstate")).mobilePhone,
        password: JSON.parse(localStorage.getItem("loginstate")).password,
      };
      console.log(data, "----218---");
      login(data).then((res) => {
        console.log(res, "----218---");
        if (res.data && res.data.code == 200) {
          localStorage.setItem("loginstate", JSON.stringify(res.data.data));
          // setTimeout(()=>{
          //   this.$router.push("/");
          // },1000)
        } else if (res.data && res.data.code == 500) {
          this.$message.warning(res.data.data);
        } else {
          this.$message.error("登录失败,请重试");
        }
      });
    },
    // ========== 新增：跳转协议页面方法 ==========
    goAgreement() {
      // 新开窗口打开协议html页面，也可根据需求改为路由跳转
      window.open("/agreement.html", "_blank");
    },
    // 提交表单
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.name == "提交") {
            publishItem(this.ruleForm).then((res) => {
              if (res.data.code == 200) {
                this.$message.success(res.data.data);
                let type = this.ruleForm.type;
                setTimeout(() => {
                  this.reset();
                  this.$store.commit("SET_ACTIVE", -1);
                  this.$router.push({ path: "/mine", query: { type: type } });
                }, 1500);
              } else if (res.data.code == 208) {
                this.$message.success("登录已经失效，请重新登录!");
                setTimeout(() => {
                  localStorage.removeItem("loginstate"),
                    this.$router.push("/login");
                }, 1500);
              } else {
                this.$message.error("发布项目失败,请重试!");
              }
            });
          } else if (this.name == "修改") {
            updateList(this.ruleForm).then((res) => {
              if (res.data.code == 200) {
                this.$message.success(res.data.data);
                let type = this.ruleForm.type;
                setTimeout(() => {
                  this.reset();
                  this.$store.commit("SET_ACTIVE", -1);
                  this.$router.push({ path: "/mine", query: { type: type } });
                }, 1500);
              } else if (res.data.code == 208) {
                this.$message.success("登录已经失效，请重新登录!");
                setTimeout(() => {
                  localStorage.removeItem("loginstate"),
                    this.$router.push("/login");
                }, 1500);
              } else {
                this.$message.error("修改项目失败,请重试!");
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    reset() {
      this.ruleForm = {
        type: "",
        projectName: "",
        projectSpend: "",
        projectDescribe: "",
        expectDay: undefined,
        contactPhone: "",
        contacts: "",
        contactAdd: "",
        proPicList: [],
        // ========== 修改：重置时清空勾选状态 ==========
        agree: false,
      };
    },
    // 上传图片
    handleUpload(file) {
      this.$nextTick(() => {
        this.$refs.uploadRef.$el.querySelector(".el-upload__input").click();
      });
    },
    // 移除图片
    handleRemove(imageUrl, index) {
      this.ruleForm.proPicList = this.ruleForm.proPicList.filter(
        (_, idx) => idx !== index,
      );
    },
    // 删除
    handleDelete() {
      this.$confirm("此操作将永久删除该项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteById(this.$route.query.id).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("删除成功!");
              let type = this.ruleForm.type;
              setTimeout(() => {
                this.reset();
                this.$store.commit("SET_ACTIVE", -1);
                this.$router.push({ path: "/mine", query: { type: type } });
              }, 1500);
            } else if (res.data.code == 208) {
              this.$message.success("登录已经失效，请重新登录!");
              setTimeout(() => {
                localStorage.removeItem("loginstate"),
                  this.$router.push("/login");
              }, 1500);
            } else {
              this.$message.error("删除失败,请重试!");
            }
          });
        })
        .catch(() => {});
    },
    // 校验
    beforeAvatarUpload(file) {
      let index = file.name.lastIndexOf(".");
      let extension = file.name.substr(index + 1);
      let extensionList = [
        "png",
        "PNG",
        "jpg",
        "JPG",
        "jpeg",
        "JPEG",
        "webp",
        "WEBP",
      ];
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message({
          message: "单张照片不可超出10M",
          type: "warning",
          center: true,
        });
        return false;
      } else if (extensionList.indexOf(extension) < 0) {
        this.$message({
          message: "当前文件格式不支持",
          type: "error",
          center: true,
        });
        return false;
      } else {
        return true;
      }
    },
    // 上传成功
    handleUploadSuccess(response, file) {
      if (response.code == 500) {
        this.$message({
          message: response.msg,
          type: "error",
          center: true,
        });
      } else if (response.data) {
        this.ruleForm.proPicList.push(response.data.path);
      }
    },
  },
  activated() {
    this.$route.query.type
      ? (this.ruleForm.type = Number(this.$route.query.type))
      : (this.ruleForm.type = "");
    if (this.$route.query.id) {
      getDetail({ id: this.$route.query.id }).then((res) => {
        if (res.data.code == 200) {
          this.ruleForm = res.data.data;
          // ========== 新增：编辑页默认勾选协议 ==========
          this.ruleForm.agree = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.name = "修改";
    } else {
      this.name = "提交";
      // ========== 新增：新增页重置勾选状态 ==========
      this.ruleForm.agree = false;
    }
    getToken().then((response) => {
      if (response.data.code == 200) {
        this.accessToken = response.data.data;
      } else {
        this.$message.error("获取token失败");
      }
    });
  },
  watch: {
    $route(to, from) {
      if (to.query.id !== from.query.id) {
        this.name = "提交";
        this.reset();
      }
    },
  },
};
</script>
<style scoped lang="less">
.normal() {
  display: flex;
  align-items: center;
}
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}
/* ========== 新增：协议链接样式 ========== */
.agreement-link {
  color: #f9c92e;
  cursor: pointer;
  text-decoration: underline;
  transition: all 0.3s ease;
  &:hover {
    color: #ffd700;
  }
}
/* 整体容器 - 深色主题适配 */
.submit {
  width: 100%;
  min-height: 100vh;
  background: #232732;
  font-family: PingFangSC, PingFang SC, -apple-system, BlinkMacSystemFont,
    sans-serif;
  &-top {
    width: 100%;
    display: block;
  }
  /* 背景容器 - 去掉原有浅色背景，适配深色主题 */
  &-background {
    width: 100%;
    background: #232732;
    padding: 60px 20px 80px;
    box-sizing: border-box;
  }
  /* 表单卡片 - 还原参考图黑色圆角卡片质感 */
  &-content {
    width: 100%;
    max-width: 900px;
    background: #121212;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 60px 80px;
    margin: 0 auto;
    position: relative;
    &-sub {
      .fontdemo(22px, "PingFangSC, PingFang SC", 400, rgba(0,0,0,0.9));
      line-height: 60px;
      cursor: pointer;
      color: coral;
      text-align: left;
    }

    /* 顶部提示文字 - 适配深色主题 */
    p {
      .fontdemo(28px, "PingFangSC,PingFang SC", 600, #ffffff);
      margin: 0 auto 10px;
      text-align: center;
      line-height: 1.3;
    }
    /* 按钮容器 */
    &-div {
      display: flex;
      align-items: center;
      margin-top: 50px;
      justify-content: center;
      gap: 30px;
    }
    /* 主按钮 - 还原参考图金色按钮风格 */
    &-send {
      width: 230px;
      height: 56px;
      background: #f9c92e;
      border-radius: 8px;
      .fontdemo(18px, "PingFangSC,PingFang SC", 600, #121212);
      line-height: 56px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;
      user-select: none;
      &:hover {
        background: #ffd700;
        transform: translateY(-2px);
      }
      /* ========== 新增：按钮禁用状态样式 ========== */
      &.is-disabled {
        background: #666666;
        cursor: not-allowed;
        opacity: 0.6;
        transform: none;
        &:hover {
          background: #666666;
          transform: none;
        }
      }
    }
    /* 删除按钮 - 适配深色主题 */
    &-delete {
      width: 230px;
      height: 56px;
      background: #2a2d3a;
      border-radius: 8px;
      .fontdemo(18px, "PingFangSC,PingFang SC", 500, #ffffff);
      line-height: 56px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;
      &:hover {
        background: #3a3d4a;
      }
    }
  }
}
/* 表单输入框、文本域通用样式 - 适配深色主题 */
/deep/ .el-textarea {
  height: 100%;
  .el-textarea__inner {
    height: 120px;
    border-radius: 8px;
    padding: 15px 18px;
    resize: none;
    background: #2a2d3a;
    border: 1px solid #3a3d4a;
    .fontdemo(15px, "PingFangSC,PingFang SC", 400, #ffffff);
    transition: all 0.3s ease;
    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
    &:focus {
      border-color: #f9c92e;
      box-shadow: 0 0 0 2px rgba(249, 201, 46, 0.1);
    }
  }
}
/deep/ .el-select,
/deep/ .el-input {
  width: 100%;
  .el-input__inner {
    width: 100%;
    height: 52px;
    border-radius: 8px;
    padding: 0 18px;
    background: #2a2d3a;
    border: 1px solid #3a3d4a;
    .fontdemo(15px, "PingFangSC,PingFang SC", 400, #ffffff);
    transition: all 0.3s ease;
    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
    &:focus {
      border-color: #f9c92e;
      box-shadow: 0 0 0 2px rgba(249, 201, 46, 0.1);
    }
  }
}
/* 表单标签样式 - 适配深色主题 */
/deep/ .el-form-item__label {
  font-size: 17px;
  font-family: PingFangSC, PingFang SC;
  color: #ffffff;
  line-height: 52px;
  font-weight: 500;
  padding-right: 20px;
}
/* 表单校验错误提示样式适配 */
/deep/ .el-form-item__error {
  color: #ff6b6b;
  padding-top: 6px;
  padding-left: 240px;
}
/* 下拉框选项深色适配 */
/deep/ .el-select-dropdown {
  background: #1a1a1a;
  border: 1px solid #3a3d4a;
  border-radius: 8px;
  .el-select-dropdown__item {
    color: #ffffff;
    background: #1a1a1a;
    &:hover {
      background: #2a2d3a;
    }
    &.selected {
      color: #f9c92e;
      font-weight: 600;
    }
  }
}
/* ========== 新增：勾选框深色主题适配 ========== */
/deep/ .el-checkbox {
  .el-checkbox__label {
    color: #ffffff;
    font-size: 15px;
    line-height: 20px;
  }
  .el-checkbox__inner {
    background: #2a2d3a;
    border-color: #3a3d4a;
    &:hover {
      border-color: #f9c92e;
    }
  }
  &.is-checked {
    .el-checkbox__inner {
      background-color: #f9c92e;
      border-color: #f9c92e;
      &::after {
        border-color: #121212;
      }
    }
  }
}
/* 图片上传区域样式 - 适配深色主题 */
.imgaeList {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
}
.list {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    opacity: 0;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.6);
    transition: opacity 0.3s;
    width: 100%;
    height: 100%;
    display: flex;
    cursor: pointer;
    .delete {
      width: 28px;
      height: 28px;
    }
  }
  &:hover .mask {
    opacity: 1;
  }
}
/* 上传按钮 - 适配深色主题 */
.list2 {
  border: 1px dashed #555555;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
  transition: all 0.3s ease;
  &:hover {
    border-color: #f9c92e;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 100%;
    line-height: 120px;
    text-align: center;
    transition: all 0.3s ease;
  }
  &:hover .avatar-uploader-icon {
    color: #f9c92e;
  }
}
</style>
